import React from 'react';
import styled from '@emotion/styled';
import { Colors } from '@blueprintjs/core';
interface IProps {
	isVertical: boolean;
}

export default function Line({ isVertical }) {
	return <Wrapper isVertical={isVertical} />;
}

const Wrapper = styled.div`
	background: ${Colors.BLACK};
	height: ${(props: IProps) => (props.isVertical ? '100%' : '1px')};
	width: ${(props: IProps) => (props.isVertical ? '1px' : '100%')};
`;
